import API from './Api'

const endpointBaseUrl = 'login';

class LoginService {
    baseUrl(){
        return endpointBaseUrl;
    }

    login(userName, password) {
        return API.post(endpointBaseUrl, { "username": userName, "password": password });
    }

    getUserInfo(token) {
        API.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        return API.get(endpointBaseUrl + '/userinfo');
    }

    registerUser(userData) {
        return API.post(endpointBaseUrl + '/register', 
            { "email": userData.email, 
              "username": userData.userName, 
              "password": userData.password, 
              "firstName": userData.firstName, 
              "lastName": userData.lastName,
              "phone": userData.phone });
    }
}

export default new LoginService();